import React, { useState, useRef } from 'react'
import { useIntl } from 'react-intl'
import AnimateHeight from 'react-animate-height'

import useOnClickOutside from 'hooks/useOnClickOutside'
import messages from 'views/CartV2/messages'
import DeliveryDetails from '..'
import AlertBadge from '../assets/alert-badge.svg'
import CheckBadge from '../assets/check-badge.svg'

const MobileDeliveryDetails = ({ delivery }) => {
  const ref = useRef(null)
  const { formatMessage } = useIntl()
  const [isExpanded, setIsExpanded] = useState(false)

  const { logisticMinimum } = delivery

  const collapseDeliveryDetails = () => {
    if (isExpanded) setIsExpanded(false)
  }
  useOnClickOutside(ref, collapseDeliveryDetails)

  return (
    <div ref={ref}>
      <button
        type="button"
        className="flex gap-4"
        onClick={() => setIsExpanded(state => !state)}
      >
        <div className="text-right whitespace-pre">
          <span className="text-label-11">
            {formatMessage(
              messages[
                isExpanded ? 'hideDeliveryDetails' : 'showDeliveryDetails'
              ],
            )}
          </span>
        </div>
        <img
          alt=""
          src={logisticMinimum.missingNet ? AlertBadge : CheckBadge}
        />
      </button>
      <AnimateHeight
        className="absolute w-full left-0"
        duration={150}
        height={isExpanded ? 'auto' : 0}
      >
        <div
          data-test-id="cart_delivery-details_mobile-container"
          className="p-6 bg-grey-150 border-b border-solid border-grey-300 rounded-b-[20px]"
        >
          <div className="pt-2.5 pl-4">
            <DeliveryDetails delivery={delivery} />
          </div>
        </div>
      </AnimateHeight>
    </div>
  )
}

export default MobileDeliveryDetails
